import LICITACION_PARTICIPANTES from '@/graphql/querys/administracion/licitaciones/participantes/licitacionParticipantes.gql';
import AGREGAR_LICITACION_FALLO from '@/graphql/mutations/administracion/licitaciones/fallo/agregarLicitacionFallo.gql';
import ACTUALIZAR_LICITACION_FALLO from '@/graphql/mutations/administracion/licitaciones/fallo/actualizarLicitacionFallo.gql';

export default {
  methods: {
    async mixAgregarLicitacionFallo() {
      this.enviandoFormulario = true;
      this.mixEsCargando();
      await this.$apollo.mutate({
        mutation: AGREGAR_LICITACION_FALLO,
        variables: {
          fallo: this.licitacionFallo,
        },
        update: (store, { data: { agregarLicitacionFallo } }) => {
          const data = store.readQuery({
            query: LICITACION_PARTICIPANTES,
            variables: {
              idLicitacion: this.$route.params.idLicitacion,
            },
          });
          data.licitacionParticipantes
            .find((participanteLicitacion) => participanteLicitacion.id
          === agregarLicitacionFallo.idParticipante)
            .fallo = agregarLicitacionFallo;
          store.writeQuery({ query: LICITACION_PARTICIPANTES, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixActualizarLicitacionFallo() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: ACTUALIZAR_LICITACION_FALLO,
        variables: {
          idParticipante: this.participanteLicitacion.fallo.idParticipante,
          fallo: this.licitacionFallo,
        },
        update: (store, { data: { actualizarLicitacionFallo } }) => {
          const data = store.readQuery({
            query: LICITACION_PARTICIPANTES,
            variables: {
              idLicitacion: this.$route.params.idLicitacion,
            },
          });
          data.licitacionParticipantes
            .find((participanteLicitacion) => participanteLicitacion.id
          === actualizarLicitacionFallo.idParticipante)
            .fallo = actualizarLicitacionFallo;
          store.writeQuery({ query: LICITACION_PARTICIPANTES, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
};
